export const VALIDATE_OTP_IS_DIGIT = new RegExp(/^\d+$/);